import React from 'react';
import Toggle from '@atlaskit/toggle';

import DraftStatusLozenge from '@/components/composed/slo-card/lozenges/draft-status-lozenge';
import { filterStore, useNavigationController } from '@/controllers';

import { filterStyles } from './styles';

const Filters: React.FC = () => {
  const { state } = React.useContext(filterStore);
  const { onNavigation } = useNavigationController();
  const { showDrafts } = state.slo;

  return (
    <div css={filterStyles}>
      <span>
        Show <DraftStatusLozenge /> SLOs
      </span>
      <Toggle
        testId="toggle-slo-show-drafts"
        onChange={() => onNavigation({ search: `showDrafts=${!showDrafts}` })}
        isChecked={showDrafts}
      />
    </div>
  );
};

export default Filters;
